import { forwardRef } from 'react';
import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button, type ButtonProps } from './button';

interface AddButtonProps extends Omit<ButtonProps, 'icon' | 'text' | 'variant' | 'size'> {
  label: string;
}

/**
 * Muted "add …" control for the empty state of a section (add task, add notes,
 * add tags). Deliberately lighter than body text: it is an offer to fill the
 * section in, so it should not out-weigh the content around it.
 */
export const AddButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, AddButtonProps>(
  function AddButton({ label, className, ...props }, ref) {
    return (
      <Button
        ref={ref}
        variant="ghost"
        size="xs"
        icon={Plus}
        text={label}
        className={cn('gap-1 px-1.5 text-gray-400 hover:text-gray-600', className)}
        {...props}
      />
    );
  },
);
